import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UiKitModule } from '@serviceplan/ui-kit';
import { MatComponentsModule } from '@thehubz/client/core';
import { ApiModule } from '@thehubz/client/data-access-api';
import { ClientLoginModule } from '@thehubz/client/login-module';
import { CustomLayoutModule } from '../layout/custom-layout.module';
import { ConfirmEmailComponent } from './components/confirm-email/confirm-email.component';
import { LoginComponent } from './components/login/login.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { SignUpSuccessComponent } from './components/sign-up-success/sign-up-success.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { LoginRoutingModule } from './login-routing.module';

@NgModule({
  declarations: [LoginComponent, SignInComponent, SignUpComponent, SignUpSuccessComponent, ConfirmEmailComponent, ResetPasswordComponent],
  imports: [
    CommonModule,
    LoginRoutingModule,
    MatComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    ApiModule,
    UiKitModule,
    ClientLoginModule,
    CustomLayoutModule,
  ],
})
export class CustomLoginModule {}
